import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaPagamentoContraCheque: ['administracao'],
    removeNomeConsultaPagamentoContraCheque: ['nome'],
    removeCpfConsultaPagamentoContraCheque: ['cpf'],
    removeCargoConsultaPagamentoContraCheque: ['cargo'],
    removeStatusConsultaPagamentoContraCheque: [],
    setMostraAplicarFiltroConsultaPagamentoContraCheque: [],
    limpaFiltroConsultaPagamentoContraCheque: [],
    aplicarFiltroConsultaPagamentoContraCheque: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    nome: '',
    cpf: '',
    cargo: [],
    mostraAplicarFiltro: false,
    status: '',
}
const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: '', mostraAplicarFiltro: true }
}

const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}

const removeCargo = (state = INITIAL_STATE, action) => {
    state.cargo.splice(state.cargo.indexOf(action.cargo), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.cargo = Array.from(state.cargo)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: removeAdministracao,
    [Types.REMOVE_NOME_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: removeNome,
    [Types.REMOVE_CPF_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: removeCpf,
    [Types.REMOVE_CARGO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: removeCargo,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: aplicarFiltro,
})
